import React from 'react';
import { Modal } from './ui/Modal';
import { Calendar, Clock, Tag } from 'lucide-react';
interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  duration: string;
  dateAdded: string;
  thumbnailUrl: string;
}
interface VideoPlayerModalProps {
  isOpen: boolean;
  onClose: () => void;
  video: Video | null;
}
export function VideoPlayerModal({
  isOpen,
  onClose,
  video
}: VideoPlayerModalProps) {
  if (!video) return null;
  return <Modal isOpen={isOpen} onClose={onClose} title={video.title} maxWidth="4xl" data-id="element-797">
      <div className="space-y-4" data-id="element-798">
        <div className="aspect-video bg-black rounded-lg overflow-hidden relative group" data-id="element-799">
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-800">
            <div className="w-16 h-16 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-orange-600 transition-colors cursor-pointer" data-id="element-801">
              <div className="w-0 h-0 border-t-[10px] border-t-transparent border-l-[18px] border-l-white border-b-[10px] border-b-transparent ml-1" data-id="element-802"></div>
            </div>
          </div>
          <img src={video.thumbnailUrl} alt={video.title} className="w-full h-full object-cover opacity-60" data-id="element-803" />
        </div>
        <div className="flex items-start justify-between" data-id="element-804">
          <div data-id="element-805">
            <div className="flex items-center gap-4 text-sm text-gray-500 mb-2" data-id="element-806">
              <span className="flex items-center gap-1" data-id="element-807">
                <Tag className="w-4 h-4" data-id="element-808" />
                {video.category}
              </span>
              <span className="flex items-center gap-1" data-id="element-809">
                <Clock className="w-4 h-4" data-id="element-810" />
                {video.duration}
              </span>
              <span className="flex items-center gap-1" data-id="element-811">
                <Calendar className="w-4 h-4" data-id="element-812" />
                {new Date(video.dateAdded).toLocaleDateString()}
              </span>
            </div>
            <p className="text-gray-700 leading-relaxed" data-id="element-813">{video.description}</p>
          </div>
        </div>
      </div>
    </Modal>;
}